import React, { useEffect } from 'react';
import { Trans, withTranslation } from 'react-i18next';
import { withStyles } from '@material-ui/styles';
import {
  Button, Tooltip,
  FormControl, Grid, MenuItem, Select, InputLabel, Step, Stepper, StepLabel, StepConnector,
} from '@material-ui/core';
import { useDispatch, useSelector } from 'react-redux';
import AOS from 'aos';
import clsx from 'clsx';

import { countries } from 'country-flags-svg';
import PhoneInput, { isPossiblePhoneNumber, isValidPhoneNumber } from 'react-phone-number-input';

import PropTypes from 'prop-types';
import styles from '../../assets/jss/requestDemoStyle';
import CModal from '../Utils/CModal';
import { getUniqueNumber } from '../Utils/Common';
import PageLoader from '../Utils/PageLoader';

import { AuthService, toasterInstance } from '../../services';
import { getSoftwareListForClient } from '../../actions';

import NameIcon from '../../assets/images/first-name.svg';
import EmailIcon from '../../assets/images/email-icon.svg';
import CompanyIcon from '../../assets/images/company-icon.svg';
import PhoneIcon from '../../assets/images/phone-icon.svg';
import CountryIcon from '../../assets/images/country-icon.svg';
import MessageIcon from '../../assets/images/message-icon.svg';

import PAMIcon from '../../assets/images/platforms/pam.svg';
import ESIcon from '../../assets/images/platforms/es.svg';
import DTIcon from '../../assets/images/platforms/dt.svg';
import ZTNIcon from '../../assets/images/platforms/ztn.svg';
import SATIcon from '../../assets/images/platforms/sat.svg';
import EPSIcon from '../../assets/images/platforms/eps.svg';
import SuccessIcon from '../../assets/images/success-icon.png';
import SuccessIcon2 from '../../assets/images/success-icon-2.png';
import ErrorIcon from '../../assets/images/cancel-icon.svg';
import ErrorIconDark from '../../assets/images/cancel-icon-dark.svg';

// import '../../../node_modules/react-phone-number-input/style.css';
import 'react-phone-number-input/style.css';

import 'aos/dist/aos.css';

import darkLogo from '../../assets/images/theme-switch-dark.svg';
import lightLogo from '../../assets/images/theme-switch-light.svg';

import { createCloudClient, checkCloudClient } from './Util';

import SFSLogo from '../../assets/images/sfs.svg';
import CipLogo from '../../assets/images/cip.svg';

import { CheckIfEmailIsValid } from '../../helper/StringUtils';

AOS.init();

const ColorlibConnector = withStyles({
  alternativeLabel: {
    top: 22,
  },
  active: {
    '& $line': {
      backgroundColor: '#09af58',
    },
  },
  completed: {
    '& $line': {
      backgroundColor: '#09af58',
    },
  },
  label: {
    fontFamily: 'Helvetica',
  },
  line: {
    height: 2,
    border: 0,
    backgroundColor: '#eaeaf0',
    borderRadius: 1,
  },
})(StepConnector);

function ColorlibStepIcon(props) {
  const {
    classes,
    propData,
  } = props;

  const {
    active,
    completed,
  } = propData;

  const icons = {
    1: 1,
    2: 2,
    3: 3,
  };
  return (
    <div
      className={clsx(classes.StepFormroot, {
        [classes.StepFormactive]: active,
        [classes.StepFormCompleted]: completed,
      })}
    >
      {icons[String(propData.icon)]}
    </div>
  );
}

ColorlibStepIcon.propTypes = {
  /**
   * Whether this step is active.
   */
  active: PropTypes.bool,
  /**
   * Mark the step as completed. Is passed to child components.
   */
  completed: PropTypes.bool,
  /**
   * The label displayed in the step icon.
   */
  icon: PropTypes.node,
};

function getSteps() {
  return [
    {
      section: 1,
      label: 'Enter Personal Details',
    },
    {
      section: 2,
      label: 'Choose Platform',
    },
    {
      section: 3,
      label: 'Review Details',
    },
  ];
}

function DemoRequestForm(props) {
  const {
    classes,
    logo,
    changeTheme,
  } = props;

  document.title = 'Software Update Portal - Crash Logs';

  function getApplicationLogo(orgData = null) {
    let data = null;

    if (orgData.code === 'DT') {
      data = {
        ...orgData,
        title: orgData.name.toUpperCase(),
        isActive: false,
        activeClass: 'dt-active title-active',
        className: 'dt',
        iconSrc: DTIcon,
        aosData: 'flip-left',
      };
    } else if (orgData.code === 'EPS') {
      data = {
        ...orgData,
        title: orgData.name.toUpperCase(),
        isActive: false,
        activeClass: 'eps-active title-active',
        className: 'eps',
        iconSrc: EPSIcon,
        aosData: 'flip-left',
      };
    } else if (orgData.code === 'AV') { //
      data = {
        ...orgData,
        title: orgData.name.toUpperCase(),
        isActive: false,
        activeClass: 'av-active title-active',
        className: 'av',
        iconSrc: EPSIcon,
        aosData: 'flip-left',
      };
    } else if (orgData.code === 'ES') {
      data = {
        ...orgData,
        title: orgData.name.toUpperCase(),
        isActive: false,
        activeClass: 'es-active title-active',
        className: 'es',
        iconSrc: ESIcon,
        aosData: 'flip-left',
      };
    } else if (orgData.code === 'PAM') {
      data = {
        ...orgData,
        title: orgData.name.toUpperCase(),
        isActive: false,
        activeClass: 'pam-active title-active',
        className: 'pam',
        iconSrc: PAMIcon,
        aosData: 'flip-left',
      };
    } else if (orgData.code === 'CIP') {
      data = {
        ...orgData,
        title: 'Cyber Intelligence Platform'.toUpperCase(),
        isActive: false,
        activeClass: 'cip-active title-active',
        className: 'cip',
        iconSrc: CipLogo,
        aosData: 'flip-left',
      };
    } else if (orgData.code === 'ZTN') {
      data = {
        ...orgData,
        title: 'Zero Trust Network'.toUpperCase(),
        isActive: false,
        activeClass: 'ztn-active title-active',
        className: 'ztn',
        iconSrc: ZTNIcon,
        aosData: 'flip-left',
      };
    } else if (orgData.code === 'SFS') { //
      data = {
        ...orgData,
        title: orgData.name.toUpperCase(),
        isActive: false,
        activeClass: 'sfs-active title-active',
        className: 'sfs',
        iconSrc: SFSLogo,
        aosData: 'flip-left',
      };
    } else if (orgData.code === 'SAT') {
      data = {
        ...orgData,
        title: orgData.name.toUpperCase(),
        isActive: false,
        activeClass: 'sat-active title-active',
        className: 'sat',
        iconSrc: SATIcon,
        aosData: 'flip-left',
      };
    }

    return data;
  }

  const dispatch = useDispatch();

  const [platformsList, setPlatformsList] = React.useState([
    {
      title: 'PRIVILEGED ACCESS MANAGEMENT',
      isActive: false,
      activeClass: 'pam-active title-active',
      className: 'pam',
      iconSrc: PAMIcon,
      aosData: 'flip-left',
    },
    {
      title: 'EMAIL SECURITY',
      isActive: false,
      activeClass: 'es-active title-active',
      className: 'es',
      iconSrc: ESIcon,
      aosData: 'flip-right',
    },
    {
      title: 'DECEPTION TECHNOLOGIES',
      isActive: false,
      activeClass: 'dt-active title-active',
      className: 'dt',
      iconSrc: DTIcon,
      aosData: 'flip-down',
    },
    {
      title: 'ZERO TRUST NETWORK',
      isActive: false,
      activeClass: 'ztn-active title-active',
      className: 'ztn',
      iconSrc: ZTNIcon,
      aosData: 'flip-up',
    },
    {
      title: 'ENDPOINT SECURITY',
      isActive: false,
      activeClass: 'eps-active title-active',
      className: 'eps',
      iconSrc: EPSIcon,
      aosData: 'flip-down',
    },
    {
      title: 'SECURITY AWARANESS TRAINING',
      isActive: false,
      activeClass: 'sat-active title-active',
      className: 'sat',
      iconSrc: SATIcon,
      aosData: 'flip-up',
    },
  ]);

  const softwareListForClient = useSelector((state) => (state.getSoftwareListForClient && state.getSoftwareListForClient.data
    ? state.getSoftwareListForClient.data
    : []));

  useEffect(() => {
    const isClient = AuthService.checkForClientApp();
    if ((isClient)) {
      dispatch(getSoftwareListForClient());
    }
  }, []);

  useEffect(() => {
    const platformsData = softwareListForClient && softwareListForClient.data && softwareListForClient.data.map((item) => {
      let obj = '';
      obj = getApplicationLogo(item, logo);
      return obj;
    });

    if (platformsData) {
      setPlatformsList(platformsData.filter(Boolean));
    }
  }, [softwareListForClient]);

  const [activeStep, setActiveStep] = React.useState(0);
  const [errorCount, setErrorCount] = React.useState(false);
  const [isError, setIsError] = React.useState(false);
  const [isFormLoading, setIsFormLoading] = React.useState(false);
  const [requestForm, setRequestForm] = React.useState({
    name: '',
    companyEmail: '',
    companyName: '',
    contactNo: '',
    country: '',
    description: '',
  });
  const [requestFormErrors, setRequestFormErrors] = React.useState({
    name: false,
    companyEmail: false,
    companyName: false,
    contactNo: false,
    country: false,
    description: false,
  });
  const [requestFormErrorMsgs, setRequestFormErrorMsgs] = React.useState({
    name: '',
    companyEmail: '',
    companyName: '',
    contactNo: '',
    country: '',
    description: '',
  });

  const steps = getSteps();

  const checkError = (domElement, name, boolean, msgString = '') => {
    let msg = msgString;
    let isError = boolean;

    if (name === 'description') {
      if (domElement.target.value.length > 500) {
        isError = true;
        msg = <Trans>VALIDATION.MAX_LENGTH_DESCRIPTION</Trans>;
      }
    }
    if (name === 'name' || name === 'companyName' || name === 'country') {
      if (domElement.target.value.length > 40) {
        isError = true;
        msg = <Trans>VALIDATION.MAX_LENGTH_TEXT</Trans>;
      }
      if (domElement.target.value.length < 1) {
        isError = true;
        if (name === 'name') msg = <Trans>VALIDATION.REQ_CNAME</Trans>;
        else if (name === 'companyName') msg = <Trans>VALIDATION.REQ_CCOM</Trans>;
        else if (name === 'country') msg = <Trans>VALIDATION.REQ_CCOUN</Trans>;
      }
    }

    const errorCheck = requestFormErrors;

    errorCheck[name] = isError;
    requestFormErrorMsgs[name] = msg;
    setRequestFormErrors({ ...errorCheck });
    setRequestFormErrorMsgs({ ...requestFormErrorMsgs });

    let newErrCount = 0;

    Object.keys(errorCheck).forEach((key) => {
      if (errorCheck[key]) {
        newErrCount += 1;
      }
    });

    setErrorCount(newErrCount);
  };

  const handleChange = (event, name) => {
    let value = '';
    if (name === 'contactNo') {
      value = event;
    } else {
      value = event.target.value;
    }
    requestForm[name] = value;

    setRequestForm({ ...requestForm });
    switch (name) {
      case 'companyEmail':
        CheckIfEmailIsValid(value)
          ? checkError(event, name, false)
          : checkError(event, name, true, <Trans>VALIDATION.EMAIL_NVALID</Trans>);
        return false;
      case 'contactNo':
        if (value) {
          if (!isValidPhoneNumber(event) || !isPossiblePhoneNumber(event)) {
            checkError(event, name, true, <Trans>VALIDATION.INV_CONTACT_NO</Trans>);
          } else {
            checkError(event, name, false);
          }
        }
        return false;
      default:
        checkError(event, name, false);
    }
  };

  const handleOption = (idx) => {
    console.log(idx);
    const platformsListNew = platformsList;
    console.log(platformsListNew[idx]);
    platformsListNew[idx].isActive = !platformsListNew[idx].isActive;
    setPlatformsList([...platformsListNew]);
  };

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  const selectedPlatforms = platformsList && platformsList.length > 0 && platformsList.filter((x) => x.isActive === true);

  const checkFormError = () => {
    if (activeStep === 0 && errorCount >= 0) {
      let msg = '';

      Object.keys(requestFormErrors).forEach((key) => {
        if (!requestFormErrors[key]) {
          if (key === 'name' && !requestForm.name) {
            msg = <Trans>VALIDATION.REQ_CNAME</Trans>;
            requestFormErrors[key] = true;
          } else if (key === 'companyName' && !requestForm.companyName) {
            msg = <Trans>VALIDATION.REQ_CCOM</Trans>;
            requestFormErrors[key] = true;
          } else if (key === 'country' && !requestForm.country) {
            msg = <Trans>VALIDATION.REQ_CCOUN</Trans>;
            requestFormErrors[key] = true;
          } else if (key === 'description' && !requestForm.description) {
            msg = '';
            requestFormErrors[key] = false;
          } else if (key === 'companyEmail' && !requestForm.companyEmail) {
            msg = <Trans>VALIDATION.REQ_EMAIL</Trans>;
            requestFormErrors[key] = true;
          } else {
            msg = '';
            requestFormErrors[key] = false;
          }
          requestFormErrorMsgs[key] = msg;
        }
      });

      setRequestFormErrors({ ...requestFormErrors });
      setRequestFormErrorMsgs({ ...requestFormErrorMsgs });

      let newErrCount = 0;

      Object.keys(requestFormErrors).forEach((key) => {
        if (requestFormErrors[key]) {
          newErrCount += 1;
        }
      });

      if (newErrCount > 0) {
        return false;
      }
    } else if (activeStep === 1 && selectedPlatforms.length <= 0) {
      toasterInstance(<Trans>VALIDATION.REQ_PLATFORM</Trans>, 4, 'errorDelete');
      return false;
    }
    return true;
  };

  const handleNext = () => {
    const checkRes = checkFormError();
    if (!checkRes) {
      return;
    }

    setActiveStep((prevActiveStep) => prevActiveStep + 1);
  };

  const [open, setOpen] = React.useState(false);
  const [errorMsg, setMsg] = React.useState('');

  const handleOpen = () => setOpen(true);

  const handleClose = () => {
    setOpen(false);
    setRequestForm({
      name: '',
      companyEmail: '',
      companyName: '',
      contactNo: '',
      country: '',
      description: '',
    });

    const platformsListNew = platformsList;
    platformsListNew.map((item) => (
      {
        ...item,
        isActive: false,
      }
    ));

    setPlatformsList([...platformsListNew]);

    setActiveStep(0);
  };

  const handleSubmit = async () => {
    const formData = requestForm;
    const data = platformsList && platformsList.length > 0 && platformsList.filter((x) => x.isActive === true);
    formData.softwares = data.map((x) => x.id);
    setIsFormLoading(false);
    await createCloudClient(formData, setIsFormLoading, setIsError, setMsg);
    setIsFormLoading(false);

    handleOpen();
  };

  const checkForm = async () => {
    const formData = requestForm;

    const checkRes = checkFormError();

    if (!checkRes) {
      return;
    }

    const data = platformsList && platformsList.length > 0 && platformsList.filter((x) => x.isActive === true);
    formData.softwares = data.map((x) => x.id);
    setIsFormLoading(false);

    const res = await checkCloudClient(formData, setIsFormLoading, setIsError, setMsg);
    setIsFormLoading(false);

    if (res) {
      handleNext();
    }
  };

  return (
    <div className={classes.body}>
      <PageLoader isLoading={isFormLoading} />
      <Tooltip title="Change Theme">
        <Button color="inherit" className="themeBtn" onClick={changeTheme}>
          {logo ? (
            <img src={darkLogo} alt="login logo" />
          ) : (
            <img src={lightLogo} alt="login logo" />
          )}
        </Button>
      </Tooltip>
      {/* <!--======Main Cloud Block--> */}
      <section className="action-box small withusbg">
        <Grid container spacing={0}>
          <Grid item xs={12} />
        </Grid>
        <div>
          <Grid container className="justify-center">
            <Grid item sm={9} md={10} xs={11} className="text-left">
              <div className="mainlogo">
                <div className="header-logo" />
              </div>

              {/* <!-- MultiStep Form --> */}
              <Grid container className="justify-center">
                <Grid item sm={9}>
                  <form id="msform">
                    {/* <!-- progressbar --> */}
                    <Stepper
                      alternativeLabel
                      activeStep={activeStep}
                      connector={<ColorlibConnector />}
                    >
                      {steps.map((x) => (
                        <Step key={x.label}>
                          <StepLabel
                            StepIconComponent={(prop) => (
                              <ColorlibStepIcon
                                propData={{ ...prop }}
                                classes={classes}
                              />
                            )}
                          >
                            {x.label}
                          </StepLabel>
                        </Step>
                      ))}
                    </Stepper>

                    {activeStep === 0 && (
                      <fieldset className="field-set">
                        <h2 className="fs-title">Personal Details</h2>

                        <div>
                          <div>
                            <Grid container className="MarginSet">
                              <Grid
                                item
                                lg={6}
                                xs={12}
                                data-aos="fade-down"
                                data-aos-duration="1200"
                              >
                                <div
                                  className={
                                    `form fname ${
                                      requestFormErrors.name && requestFormErrorMsgs.name
                                        ? 'error-msg'
                                        : ''}`
                                  }
                                >
                                  <img alt="" src={NameIcon} className="field-icon" />
                                  <input
                                    type="text"
                                    onChange={(e) => handleChange(e, 'name')}
                                    value={requestForm.name}
                                    name="name"
                                    // autocomplete="off"
                                    required
                                  />
                                  <label htmlFor="text" className="label-name">
                                    <span className="content-name">First/Last name</span>
                                  </label>
                                  {requestFormErrors.name && requestFormErrorMsgs.name ? (
                                    <p className="error-message">{requestFormErrorMsgs.name}</p>
                                  ) : (
                                    ''
                                  )}
                                </div>
                              </Grid>

                              <Grid
                                item
                                lg={6}
                                xs={12}
                                data-aos="fade-up"
                                data-aos-duration="1400"
                              >
                                <div
                                  className={
                                    `form email ${
                                      requestFormErrors.companyEmail
                                      && requestFormErrorMsgs.companyEmail
                                        ? 'error-msg'
                                        : ''}`
                                  }
                                >
                                  <img alt="" src={EmailIcon} className="field-icon" />
                                  <input
                                    type="text"
                                    onChange={(e) => handleChange(e, 'companyEmail')}
                                    value={requestForm.companyEmail}
                                    name="companyEmail"
                                    // autocomplete="off"
                                    required
                                  />
                                  <label htmlFor="text" className="label-name">
                                    <span className="content-name">Company email address</span>
                                  </label>
                                  {requestFormErrors.companyEmail
                                  && requestFormErrorMsgs.companyEmail ? (
                                    <p className="error-message">
                                      {requestFormErrorMsgs.companyEmail}
                                    </p>
                                    ) : (
                                      ''
                                    )}
                                </div>
                              </Grid>

                              <Grid
                                item
                                lg={6}
                                xs={12}
                                data-aos="fade-up"
                                data-aos-duration="1600"
                              >
                                <div
                                  className={
                                    `form company ${
                                      requestFormErrors.companyName
                                      && requestFormErrorMsgs.companyName
                                        ? 'error-msg'
                                        : ''}`
                                  }
                                >
                                  <img alt="" src={CompanyIcon} className="field-icon" />
                                  <input
                                    type="text"
                                    name="companyName"
                                    onChange={(e) => handleChange(e, 'companyName')}
                                    value={requestForm.companyName}
                                    // autocomplete="off"
                                    required
                                  />
                                  <label htmlFor="text" className="label-name">
                                    <span className="content-name">Company name</span>
                                  </label>
                                  {requestFormErrors.companyName
                                  && requestFormErrorMsgs.companyName ? (
                                    <p className="error-message">
                                      {requestFormErrorMsgs.companyName}
                                    </p>
                                    ) : (
                                      ''
                                    )}
                                </div>
                              </Grid>

                              <Grid
                                item
                                lg={6}
                                xs={12}
                                data-aos="fade-right"
                                data-aos-duration="2000"
                              >
                                <div className={
                                  `form phone ${
                                    requestFormErrors.contactNo && requestFormErrorMsgs.contactNo
                                      ? 'error-msg'
                                      : ''}`
                                }
                                >
                                  <img alt="" className="country-flag-icon field-icon" src={PhoneIcon} />

                                  <PhoneInput
                                    id="demo-simple-select-label-sm"
                                    style={{ position: 'relative' }}
                                    international
                                    name="contactNo"
                                    onChange={(e) => handleChange(e, 'contactNo')}
                                    value={requestForm.contactNo || null}
                                    placeholder="helo"
                                    defaultCountry="US"
                                    label={<Trans>CLOUD_CLIENT.CONTACT</Trans>}
                                  />
                                  <label htmlFor="text" className="label-name">
                                    <span className="content-name">Phone number</span>
                                  </label>
                                  {requestFormErrors.contactNo
                                  && requestFormErrorMsgs.contactNo ? (
                                    <p className="error-message">
                                      {requestFormErrorMsgs.contactNo}
                                    </p>
                                    ) : (
                                      ''
                                    )}

                                </div>
                              </Grid>
                              <Grid
                                item
                                lg={12}
                                xs={12}
                                data-aos="fade-right"
                                data-aos-duration="2000"
                              >
                                <div
                                  className={
                                    `form country ${
                                      requestFormErrors.country && requestFormErrorMsgs.country
                                        ? 'error-msg'
                                        : ''}`
                                  }
                                >
                                  <img alt="" src={CountryIcon} className="field-icon" />
                                  <FormControl
                                    className={`${classes.formControl} ${classes.selectBoxDiv} ${classes.formInp} ${classes.MarginSet}`}
                                    variant="filled"
                                  >

                                    <InputLabel id="demo-simple-select-label">
                                      {' '}
                                      <Trans>CLOUD_CLIENT.COUNTRY</Trans>
                                      *
                                    </InputLabel>
                                    <Select
                                      label={(
                                        <>
                                          <Trans>CLOUD_CLIENT.COUNTRY</Trans>
                                          *
                                        </>
                                      )}
                                      id="demo-simple-chip"
                                      // value={country}
                                      value={requestForm.country || null}
                                      name="country"
                                      onChange={(e) => handleChange(e, 'country')}
                                    >
                                      {countries.map((country) => (
                                        <MenuItem key={country.name} value={country.name}>
                                          <img
                                            src={country.flag}
                                            alt=""
                                            width={20}
                                            style={{ paddingRight: '10px' }}
                                          />
                                          {country.name}
                                        </MenuItem>
                                      ))}
                                    </Select>
                                  </FormControl>
                                  {requestFormErrors.country && requestFormErrorMsgs.country ? (
                                    <p className="error-message">
                                      {requestFormErrorMsgs.country}
                                    </p>
                                  ) : (
                                    ''
                                  )}
                                </div>
                              </Grid>

                              <Grid item xs={12} data-aos="fade-down" data-aos-duration="1800">
                                <div
                                  className={
                                    `form message ${
                                      requestFormErrors.description
                                      && requestFormErrorMsgs.description
                                        ? 'error-msg'
                                        : ''}`
                                  }
                                >
                                  <img alt="" src={MessageIcon} className="field-icon" />
                                  <textarea
                                    name="description"
                                    onChange={(e) => handleChange(e, 'description')}
                                    value={requestForm.description}
                                    required
                                    cols="10"
                                    rows="7"
                                  />
                                  <label htmlFor="text" className="label-name">
                                    <span className="content-name">Comments</span>
                                  </label>
                                  {requestFormErrors.description
                                  && requestFormErrorMsgs.description ? (
                                    <p className="error-message">
                                      {requestFormErrorMsgs.description}
                                    </p>
                                    ) : (
                                      ''
                                    )}
                                </div>
                              </Grid>
                            </Grid>
                          </div>
                        </div>

                        <input
                          type="button"
                          name="next"
                          className="next action-button"
                          onClick={checkForm}
                          value="Next"
                        />
                      </fieldset>
                    )}

                    {activeStep === 1 && (
                      <fieldset className="field-set">
                        <h2 className="fs-title">Choose Platform</h2>
                        <Grid container justify="space-between">
                          {/* <!------- Block Widgets-------->    */}
                          {platformsList
                          && platformsList.map((x, i) => (
                            <Grid
                              key={`${getUniqueNumber()}-o`}
                              item
                              md={6}
                              xs={12}
                              data-aos={x.aosData}
                              data-aos-duration="1800"
                              className="p-set"
                            >
                              <div
                                aria-hidden="true"
                                className={`inside-block  ${x.className} ${x.isActive ? x.activeClass : ' '}`}
                                onClick={() => handleOption(i)}
                              >
                                <Grid container justify="center">
                                  <Grid item lg={4} xs={12} className="padding-set">
                                    <div className={`icon  ${x.className}`}>
                                      <img alt="" src={x.iconSrc} />
                                    </div>
                                  </Grid>
                                  <Grid item lg={8} xs={12} className="padding-set">
                                    <h2>{x.title}</h2>
                                  </Grid>
                                </Grid>
                              </div>
                            </Grid>
                          ))}
                        </Grid>
                        <input
                          type="button"
                          name="previous"
                          onClick={handleBack}
                          className="previous action-button-previous"
                          value="Previous"
                        />

                        <input
                          type="button"
                          name="next"
                          className="next action-button"
                          onClick={handleNext}
                          value="Next"
                        />
                        {/* <input type="submit" name="submit" className="submit action-button" value="Submit"/>  */}
                      </fieldset>
                    )}

                    {activeStep === 2 && (
                      <fieldset className="field-set">
                        <h2 className="fs-title">Review Details</h2>
                        <Grid container className="w-link">
                          {/* <!------- Block Widgets-------->    */}
                          <Grid item xs={12} className="mb5">
                            <div className="listblock">
                              <div className="icon input-icon">
                                <img alt="" src={NameIcon} />
                              </div>
                              <h1>First/Last Name:</h1>
                              <h2>{requestForm.name}</h2>
                              {' '}
                            </div>
                          </Grid>
                          {/* <!------- Block Widgets-------->

<!------- Block Widgets-------->    */}
                          <Grid item xs={12} className="mb5">
                            <div className="listblock">
                              <div className="icon input-icon">
                                <img alt="" src={EmailIcon} />
                              </div>
                              <h1>Company email address:</h1>
                              <h2>{requestForm.companyEmail}</h2>
                              {' '}
                            </div>
                          </Grid>
                          {/* <!------- Block Widgets-------->

<!------- Block Widgets-------->    */}
                          <Grid item xs={12} className="mb5">
                            <div className="listblock">
                              <div className="icon input-icon">
                                <img alt="" src={CompanyIcon} />
                              </div>
                              <h1>Company name:</h1>
                              <h2>{requestForm.companyName}</h2>
                              {' '}
                            </div>
                          </Grid>
                          {/* <!------- Block Widgets-------->

<!------- Block Widgets-------->    */}
                          <Grid item xs={12} className="mb5">
                            <div className="listblock">
                              <div className="icon input-icon">
                                <img alt="" src={PhoneIcon} />
                              </div>
                              <h1>Phone Number:</h1>
                              <h2>{requestForm.contactNo}</h2>
                              {' '}
                            </div>
                          </Grid>
                          {/* <!------- Block Widgets-------->   */}

                          {/* <!------- Block Widgets-------->    */}
                          <Grid item xs={12} className="mb5">
                            <div className="listblock">
                              <div className="icon input-icon">
                                <img alt="" src={CountryIcon} />
                              </div>
                              <h1>Country name:</h1>
                              <h2>{requestForm.country}</h2>
                              {' '}
                            </div>
                          </Grid>
                          {/* <!------- Block Widgets-------->   */}

                          {/* <!------- Block Widgets-------->    */}
                          <Grid item xs={12} className="mb5">
                            <div className="listblock">
                              <div className="icon input-icon">
                                <img alt="" src={MessageIcon} />
                              </div>
                              <h1>Comments:</h1>
                              <h2>{requestForm.description}</h2>
                              {' '}
                            </div>
                          </Grid>
                          {/* <!------- Block Widgets-------->    */}
                        </Grid>

                        <h2 className="fs-title mt35">Selected Platform</h2>
                        <div className="row mb15">
                          {/* <!------- Block Widgets-------->    */}
                          {selectedPlatforms
                          && selectedPlatforms.map((x) => (
                            <div key={`${getUniqueNumber()}-r`} className="col-sm-12 mb15">
                              <div className="listblock">
                                <div className={`icon selected ${x.activeClass}`}>
                                  <img alt="" src={x.iconSrc} />
                                </div>
                                <h1 className="ch_lh">Selected Platform:</h1>
                                <h2 className="ch_lh pl14">
                                  <strong>{x.title}</strong>
                                </h2>
                                {' '}
                              </div>
                            </div>
                          ))}
                          {/* <!------- Block Widgets-------->   */}
                        </div>

                        <input
                          type="button"
                          name="previous"
                          onClick={handleBack}
                          className="previous action-button-previous"
                          value="Previous"
                        />

                        <button
                          type="button"
                          onClick={handleSubmit}
                          className="btn action-button"
                          data-toggle="modal"
                          data-target="#exampleModal"
                        >
                          Submit
                        </button>
                      </fieldset>
                    )}

                    {/* <!-- Modal --> */}
                    <div className="modal-div">
                      <CModal
                        open={open}
                        onClose={handleClose}
                        fromRequestDemo
                        aria-labelledby="modal-modal-title"
                        aria-describedby="modal-modal-description"
                      >
                        <span id="msform2">
                          {!isError ? (
                            <div
                              className="modal fade darkmodal"
                              id="exampleModal"
                              tabIndex="-1"
                              role="dialog"
                              aria-labelledby="exampleModalLabel"
                              aria-hidden="true"
                            >
                              <div className="modal-dialog" role="document">
                                <div className="modal-content">
                                  <div className="modal-header">
                                    {logo ? (
                                      <img src={SuccessIcon} alt="login logo" />
                                    ) : (
                                      <img src={SuccessIcon2} alt="login logo" />
                                    )}
                                  </div>
                                  <div className="modal-body">
                                    <h2>Your Request has been submitted successfully</h2>
                                  </div>
                                  <div className="modal-footer">
                                    <button
                                      type="button"
                                      onClick={handleClose}
                                      className="btn action-button"
                                      data-dismiss="modal"
                                    >
                                      Close
                                    </button>
                                  </div>
                                </div>
                              </div>
                            </div>
                          ) : (
                            <div
                              className="modal fade darkmodal"
                              id="exampleModal"
                              tabIndex="-1"
                              role="dialog"
                              aria-labelledby="exampleModalLabel"
                              aria-hidden="true"
                            >
                              <div className="modal-dialog" role="document">
                                <div className="modal-content failure-div">
                                  <div className="modal-header">
                                    {logo ? (
                                      <img src={ErrorIconDark} alt="login logo" />
                                    ) : (
                                      <img src={ErrorIcon} alt="login logo" />
                                    )}
                                  </div>
                                  <div className="modal-body">
                                    <h2>{errorMsg}</h2>
                                  </div>
                                  <div className="modal-footer">
                                    <button
                                      type="button"
                                      onClick={handleClose}
                                      className="btn action-button"
                                      data-dismiss="modal"
                                    >
                                      Close
                                    </button>
                                  </div>
                                </div>
                              </div>
                            </div>
                          )}
                        </span>
                      </CModal>
                    </div>
                  </form>
                </Grid>
              </Grid>
              {/* <!-- /.MultiStep Form -->  */}
            </Grid>
          </Grid>
        </div>
      </section>
      {/* <!--======Main Cloud Block --> */}
    </div>
  );
}

export default withTranslation()(withStyles(styles, { withTheme: true })(DemoRequestForm));
